import { api } from './api';
import { EmailDetail } from '../types';

export async function getEmailDetails(emailId: string): Promise<EmailDetail> {
  const response = await api.get(`emails/${emailId}`);
  return response.json();
}
